(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/subscription-router.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/subscription-router.js');
"use strict";


const {
  Fragment
} = React;
const {
  Route
} = svs.app.ReactRouter;
const {
  CHOOSE,
  CONFIRMATION
} = svs.ticketsOrderHome.routes.SUBSCRIPTION;
const NavigationBack = svs.tur.NavigationBack;
const branding = svs.tickets.data.templateConfig.branding === 'triss' ? 'triss' : null;
const routes = {
  [CHOOSE]: {
    text: 'Beställ hem/',
    path: () => svs.core.data.baseUrl
  }
};
const breadcrum = 'Prenumeration';
const SubscriptionRouter = () => React.createElement(Fragment, null, React.createElement(NavigationBack, {
  brand: branding,
  breadcrum: breadcrum,
  routes: routes
}), React.createElement(Route, {
  component: () => React.createElement("div", null, CHOOSE),
  path: CHOOSE
}), " ", React.createElement(Route, {
  component: () => React.createElement("div", null, CONFIRMATION),
  path: CONFIRMATION
}), " ");
setGlobal('svs.ticketsOrderHome.SubscriptionRouter', SubscriptionRouter);

 })(window);